import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss'],
})
export class UploadImageComponent implements OnDestroy {
  selectedFile: File | null = null;
  @Output() fileData: EventEmitter<{ file: File; url: string }> = new EventEmitter<{ file: File; url: string }>();

  ngOnDestroy() {
    if (this.selectedFile) {
      const fileUrl = URL.createObjectURL(this.selectedFile);
      URL.revokeObjectURL(fileUrl);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.selectedFile = input.files[0];
      const fileUrl = URL.createObjectURL(this.selectedFile);

      this.fileData.emit({
        file: this.selectedFile,
        url: fileUrl,
      });
    }
  }
}
